import { motion } from 'framer-motion';
import { Phone, Mail, MapPin, Clock, Heart, ExternalLink } from 'lucide-react';

const contactItems = [
  { icon: Phone, title: 'Phone', value: '971-867-0536', link: 'tel:971-867-0536', color: 'bg-primary', lightBg: 'bg-primary/10' },
  { icon: Mail, title: 'Email', value: 'hooyosplace26@gmail.com', link: 'mailto:hooyosplace26@gmail.com', color: 'bg-secondary', lightBg: 'bg-secondary/10' },
  { icon: MapPin, title: 'Location', value: 'Portland / Beaverton Metro Area', link: null, color: 'bg-success', lightBg: 'bg-success/10' },
  { icon: Clock, title: 'Hours', value: 'Mon - Fri: 7:00 AM - 8:00 PM', link: null, color: 'bg-accent', lightBg: 'bg-accent/15' },
];

const stagger = { hidden: {}, show: { transition: { staggerChildren: 0.08 } } };
const fadeUp = { hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0, transition: { duration: 0.35 } } };

const MobileContact = () => (
  <div className="pb-6" data-testid="mobile-contact">
    {/* Header */}
    <div className="text-center pt-6 pb-4 px-6">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
        <div className="w-14 h-14 rounded-2xl bg-success/10 flex items-center justify-center mx-auto mb-3">
          <Phone className="w-7 h-7 text-success-foreground" />
        </div>
        <h2 className="font-fredoka font-bold text-xl text-foreground" data-testid="mobile-contact-heading">Get in Touch</h2>
        <p className="text-xs text-muted-foreground mt-1">We'd love to hear from you!</p>
      </motion.div>
    </div>

    {/* Contact Cards */}
    <motion.div variants={stagger} initial="hidden" animate="show" className="px-4 space-y-3">
      {contactItems.map(({ icon: Icon, title, value, link, color, lightBg }) => {
        const card = (
          <motion.div variants={fadeUp} className="bg-white rounded-2xl p-4 border border-border/30 shadow-soft flex items-center gap-4 active:scale-[0.98] transition-transform" data-testid={`mobile-contact-${title.toLowerCase()}`}>
            <div className={`w-12 h-12 rounded-xl ${color} flex items-center justify-center flex-shrink-0`}>
              <Icon className="w-6 h-6 text-white" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground font-semibold uppercase tracking-wider">{title}</p>
              <p className="font-fredoka font-semibold text-sm text-foreground mt-0.5 truncate">{value}</p>
            </div>
            {link && <ExternalLink className="w-4 h-4 text-muted-foreground/40 flex-shrink-0" />}
          </motion.div>
        );
        return link ? <a key={title} href={link} className="block">{card}</a> : <div key={title}>{card}</div>;
      })}
    </motion.div>

    {/* Message Card */}
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.4, duration: 0.4 }}
      className="mx-4 mt-6 p-5 bg-secondary/8 rounded-2xl border border-secondary/15"
    >
      <div className="flex items-start gap-3">
        <Heart className="w-5 h-5 text-secondary flex-shrink-0 mt-0.5" />
        <div>
          <p className="font-fredoka font-semibold text-sm text-foreground mb-1">Visit Us!</p>
          <p className="text-xs text-muted-foreground leading-relaxed">
            We welcome walk-in visits during business hours. Schedule a tour for a guided experience of our warm, welcoming learning environment.
          </p>
        </div>
      </div>
    </motion.div>

    {/* Quick Links */}
    <div className="px-4 mt-6 space-y-2">
      <a href="https://hooyosplace.net" target="_blank" rel="noopener noreferrer" className="block bg-white rounded-2xl p-4 border border-border/30 shadow-soft text-center" data-testid="mobile-contact-website">
        <p className="font-fredoka font-semibold text-sm text-secondary">Visit Our Website</p>
        <p className="text-xs text-muted-foreground mt-0.5">hooyosplace.net</p>
      </a>
    </div>
  </div>
);

export default MobileContact;
